import { InjectionToken } from "@angular/core";
import { ICommonErrorHandlerService } from "../interfaces/common-error-handler";

/**
 * The default message used for exceptions
 */
export const DEFAULT_EXCEPTION_MESSAGE = "An error has occurred. Please try again, or contact support if this occurs again.";

/**
 * Injection token for the COMMON_ERROR_HANDLER
 *
 * const errorHandler = inject(COMMON_ERROR_HANDLER);
 */
export const COMMON_ERROR_HANDLER = new InjectionToken<ICommonErrorHandlerService>("ICommonErrorHandlerService");
